/**
 * A list of all countries, code and name.
 * @type {!Array<!Object>}
 */
export const COUNTRIES = [
    {'name': 'Afghanistan', 'iso2': 'AF', 'iso3': 'AFG', 'sapName': 'Afghanistan'},
    {'name': 'Albania', 'iso2': 'AL', 'iso3': 'ALB', 'sapName': 'Albania'},
    {'name': 'Algeria', 'iso2': 'DZ', 'iso3': 'DZA', 'sapName': 'Algeria'},
    {'name': 'Andorra', 'iso2': 'AD', 'iso3': 'AND', 'sapName': 'Andorra'},
    {'name': 'Angola', 'iso2': 'AO', 'iso3': 'AGO', 'sapName': 'Angola'},
    {'name': 'Anguilla', 'iso2': 'AI', 'iso3': 'AIA', 'sapName': 'Anguilla'},
    {'name': 'Antigua and Barbuda', 'iso2': 'AG', 'iso3': 'ATG', 'sapName': 'Antigua/Barbuda'},
    {'name': 'Argentina', 'iso2': 'AR', 'iso3': 'ARG', 'sapName': 'Argentina'},
    {'name': 'Armenia', 'iso2': 'AM', 'iso3': 'ARM', 'sapName': 'Armenia'},
    {'name': 'Aruba', 'iso2': 'AW', 'iso3': 'ABW', 'sapName': 'Aruba'},
    {'name': 'Australia', 'iso2': 'AU', 'iso3': 'AUS', 'sapName': 'Australia'},
    {'name': 'Austria', 'iso2': 'AT', 'iso3': 'AUT', 'sapName': 'Austria'},
    {'name': 'Azerbaijan', 'iso2': 'AZ', 'iso3': 'AZE', 'sapName': 'Azerbaijan'},
    {'name': 'Bahamas', 'iso2': 'BS', 'iso3': 'BHS', 'sapName': 'Bahamas'},
    {'name': 'Bahrain', 'iso2': 'BH', 'iso3': 'BHR', 'sapName': 'Bahrain'},
    {'name': 'Bangladesh', 'iso2': 'BD', 'iso3': 'BGD', 'sapName': 'Bangladesh'},
    {'name': 'Barbados', 'iso2': 'BB', 'iso3': 'BRB', 'sapName': 'Barbados'},
    {'name': 'Belarus', 'iso2': 'BY', 'iso3': 'BLR', 'sapName': 'Belarus'},
    {'name': 'Belgium', 'iso2': 'BE', 'iso3': 'BEL', 'sapName': 'Belgium'},
    {'name': 'Belize', 'iso2': 'BZ', 'iso3': 'BLZ', 'sapName': 'Belize'},
    {'name': 'Benin', 'iso2': 'BJ', 'iso3': 'BEN', 'sapName': 'Benin'},
    {'name': 'Bermuda', 'iso2': 'BM', 'iso3': 'BMU', 'sapName': 'Bermuda'},
    {'name': 'Bhutan', 'iso2': 'BT', 'iso3': 'BTN', 'sapName': 'Bhutan'},
    {'name': 'Bosnia and Herzegovina', 'iso2': 'BA', 'iso3': 'BIH', 'sapName': 'Bosnia-Herz.'},
    {'name': 'Botswana', 'iso2': 'BW', 'iso3': 'BWA', 'sapName': 'Botswana'},
    {'name': 'Bouvet Island', 'iso2': 'BV', 'iso3': 'BVT', 'sapName': 'Bouvet Island'},
    {'name': 'Brazil', 'iso2': 'BR', 'iso3': 'BRA', 'sapName': 'Brazil'},
    {'name': 'British Indian Ocean Territory', 'iso2': 'IO', 'iso3': 'IOT', 'sapName': 'Brit.Ind.Oc.Ter'},
    {'name': 'Brunei Darussalam', 'iso2': null, 'iso3': null, 'sapName': 'Brunei Darussal'},
    {'name': 'Bulgaria', 'iso2': 'BG', 'iso3': 'BGR', 'sapName': 'Bulgaria'},
    {'name': 'Burkina Faso', 'iso2': 'BF', 'iso3': 'BFA', 'sapName': 'Burkina-Faso'},
    {'name': 'Burundi', 'iso2': 'BI', 'iso3': 'BDI', 'sapName': 'Burundi'},
    {'name': 'Cambodia', 'iso2': 'KH', 'iso3': 'KHM', 'sapName': 'Cambodia'},
    {'name': 'Cameroon', 'iso2': 'CM', 'iso3': 'CMR', 'sapName': 'Cameroon'},
    {'name': 'Canada', 'iso2': 'CA', 'iso3': 'CAN', 'sapName': 'Canada'},
    {'name': 'Cape Verde', 'iso2': 'CV', 'iso3': 'CPV', 'sapName': 'Cape Verde'},
    {'name': 'Cayman Islands', 'iso2': 'KY', 'iso3': 'CYM', 'sapName': 'Cayman Islands'},
    {'name': 'Central African Republic', 'iso2': 'CF', 'iso3': 'CAF', 'sapName': 'Central Afr.Rep'},
    {'name': 'Chad', 'iso2': 'TD', 'iso3': 'TCD', 'sapName': 'Chad'},
    {'name': 'Chile', 'iso2': 'CL', 'iso3': 'CHL', 'sapName': 'Chile'},
    {'name': 'China', 'iso2': 'CN', 'iso3': 'CHN', 'sapName': 'China'},
    {'name': 'Christmas Island', 'iso2': 'CX', 'iso3': 'CXR', 'sapName': 'Christmas Island'},
    {'name': 'Cocos (Keeling) Islands', 'iso2': null, 'iso3': null, 'sapName': 'Cocos (Keeling)'},
    {'name': 'Colombia', 'iso2': 'CO', 'iso3': 'COL', 'sapName': 'Colombia'},
    {'name': 'Comoros', 'iso2': 'KM', 'iso3': 'COM', 'sapName': 'Comoros'},
    {'name': 'Congo', 'iso2': null, 'iso3': null, 'sapName': 'Congo'},
    {'name': 'Cook Islands', 'iso2': 'CK', 'iso3': 'COK', 'sapName': 'Cook Islands'},
    {'name': 'Costa Rica', 'iso2': 'CR', 'iso3': 'CRI', 'sapName': 'Costa Rica'},
    {'name': 'Croatia', 'iso2': 'HR', 'iso3': 'HRV', 'sapName': 'Croatia'},
    {'name': 'Cuba', 'iso2': 'CU', 'iso3': 'CUB', 'sapName': 'Cuba'},
    {'name': 'Cyprus', 'iso2': 'CY', 'iso3': 'CYP', 'sapName': 'Cyprus'},
    {'name': 'Czech Republic', 'iso2': 'CZ', 'iso3': 'CZE', 'sapName': 'Czech Republic'},
    {'name': 'Denmark', 'iso2': 'DK', 'iso3': 'DNK', 'sapName': 'Denmark'},
    {'name': 'Djibouti', 'iso2': 'DJ', 'iso3': 'DJI', 'sapName': 'Djibouti'},
    {'name': 'Dominica', 'iso2': 'DM', 'iso3': 'DMA', 'sapName': 'Dominica'},
    {'name': 'Dominican Republic', 'iso2': 'DO', 'iso3': 'DOM', 'sapName': 'Dominican Rep.'},
    {'name': 'Ecuador', 'iso2': 'EC', 'iso3': 'ECU', 'sapName': 'Ecuador'},
    {'name': 'Egypt', 'iso2': 'EG', 'iso3': 'EGY', 'sapName': 'Egypt'},
    {'name': 'El Salvador', 'iso2': 'SV', 'iso3': 'SLV', 'sapName': 'El Salvador'},
    {'name': 'Equatorial Guinea', 'iso2': 'GQ', 'iso3': 'GNQ', 'sapName': 'Equatorial Gui.'},
    {'name': 'Eritrea', 'iso2': 'ER', 'iso3': 'ERI', 'sapName': 'Eritrea'},
    {'name': 'Estonia', 'iso2': 'EE', 'iso3': 'EST', 'sapName': 'Estonia'},
    {'name': 'Ethiopia', 'iso2': 'ET', 'iso3': 'ETH', 'sapName': 'Ethiopia'},
    {'name': 'Falkland Islands (Malvinas)', 'iso2': null, 'iso3': null, 'sapName': 'Falkland Islands (Malvinas)'},
    {'name': 'Faroe Islands', 'iso2': 'FO', 'iso3': 'FRO', 'sapName': 'Faroe Islands'},
    {'name': 'Fiji', 'iso2': 'FJ', 'iso3': 'FJI', 'sapName': 'Fiji'},
    {'name': 'Finland', 'iso2': 'FI', 'iso3': 'FIN', 'sapName': 'Finland'},
    {'name': 'France', 'iso2': 'FR', 'iso3': 'FRA', 'sapName': 'France'},
    {'name': 'French Guiana', 'iso2': 'GF', 'iso3': 'GUF', 'sapName': 'French Guiana'},
    {'name': 'French Polynesia', 'iso2': 'PF', 'iso3': 'PYF', 'sapName': 'Frenc.Polynesia'},
    {'name': 'Gabon', 'iso2': 'GA', 'iso3': 'GAB', 'sapName': 'Gabon'},
    {'name': 'Gambia', 'iso2': 'GM', 'iso3': 'GMB', 'sapName': 'Gambia'},
    {'name': 'Georgia', 'iso2': 'GE', 'iso3': 'GEO', 'sapName': 'Georgia'},
    {'name': 'Germany', 'iso2': 'DE', 'iso3': 'DEU', 'sapName': 'Germany'},
    {'name': 'Ghana', 'iso2': 'GH', 'iso3': 'GHA', 'sapName': 'Ghana'},
    {'name': 'Gibraltar', 'iso2': 'GI', 'iso3': 'GIB', 'sapName': 'Gibraltar'},
    {'name': 'Greece', 'iso2': 'GR', 'iso3': 'GRC', 'sapName': 'Greece'},
    {'name': 'Greenland', 'iso2': 'GL', 'iso3': 'GRL', 'sapName': 'Greenland'},
    {'name': 'Grenada', 'iso2': 'GD', 'iso3': 'GRD', 'sapName': 'Grenada'},
    {'name': 'Guadeloupe', 'iso2': 'GP', 'iso3': 'GLP', 'sapName': 'Guadeloupe'},
    {'name': 'Guam', 'iso2': 'GU', 'iso3': 'GUM', 'sapName': 'Guam'},
    {'name': 'Guatemala', 'iso2': 'GT', 'iso3': 'GTM', 'sapName': 'Guatemala'},
    {'name': 'Guernsey', 'iso2': 'GG', 'iso3': 'GGY', 'sapName': 'Guernsey'},
    {'name': 'Guinea', 'iso2': 'GN', 'iso3': 'GIN', 'sapName': 'Guinea'},
    {'name': 'Guinea-Bissau', 'iso2': 'GW', 'iso3': 'GNB', 'sapName': 'Guinea-Bissau'},
    {'name': 'Guyana', 'iso2': 'GY', 'iso3': 'GUY', 'sapName': 'Guyana'},
    {'name': 'Haiti', 'iso2': 'HT', 'iso3': 'HTI', 'sapName': 'Haiti'},
    {'name': 'Heard Island and McDonald Islands', 'iso2': 'HM', 'iso3': 'HMD', 'sapName': 'Heard/McDon.Isl'},
    {'name': 'Holy See (Vatican City State)', 'iso2': null, 'iso3': null, 'sapName': 'Holy See (Vatican City State)'},
    {'name': 'Honduras', 'iso2': 'HN', 'iso3': 'HND', 'sapName': 'Honduras'},
    {'name': 'Hong Kong', 'iso2': 'HK', 'iso3': 'HKG', 'sapName': 'Hong Kong/China'},
    {'name': 'Hungary', 'iso2': 'HU', 'iso3': 'HUN', 'sapName': 'Hungary'},
    {'name': 'Iceland', 'iso2': 'IS', 'iso3': 'ISL', 'sapName': 'Iceland'},
    {'name': 'India', 'iso2': 'IN', 'iso3': 'IND', 'sapName': 'India'},
    {'name': 'Indonesia', 'iso2': 'ID', 'iso3': 'IDN', 'sapName': 'Indonesia'},
    {'name': 'Iran', 'iso2': 'IR', 'iso3': 'IRN', 'sapName': 'Iran'},
    {'name': 'Iraq', 'iso2': 'IQ', 'iso3': 'IRQ', 'sapName': 'Iraq'},
    {'name': 'Ireland', 'iso2': 'IE', 'iso3': 'IRL', 'sapName': 'Ireland'},
    {'name': 'Isle of Man', 'iso2': 'IM', 'iso3': 'IMN', 'sapName': 'Isle of Man'},
    {'name': 'Israel', 'iso2': 'IL', 'iso3': 'ISR', 'sapName': 'Israel'},
    {'name': 'Italy', 'iso2': 'IT', 'iso3': 'ITA', 'sapName': 'Italy'},
    {'name': 'Ivory Coast', 'iso2': 'CI', 'iso3': 'CIV', 'sapName': 'Ivory Coast'},
    {'name': 'Jamaica', 'iso2': 'JM', 'iso3': 'JAM', 'sapName': 'Jamaica'},
    {'name': 'Japan', 'iso2': 'JP', 'iso3': 'JPN', 'sapName': 'Japan'},
    {'name': 'Jersey', 'iso2': 'JE', 'iso3': 'JEY', 'sapName': 'Jersey'},
    {'name': 'Jordan', 'iso2': 'JO', 'iso3': 'JOR', 'sapName': 'Jordan'},
    {'name': 'Kazakhstan', 'iso2': 'KZ', 'iso3': 'KAZ', 'sapName': 'Kazakhstan'},
    {'name': 'Kenya', 'iso2': 'KE', 'iso3': 'KEN', 'sapName': 'Kenya'},
    {'name': 'Kiribati', 'iso2': 'KI', 'iso3': 'KIR', 'sapName': 'Kiribati'},
    {'name': 'Kuwait', 'iso2': 'KW', 'iso3': 'KWT', 'sapName': 'Kuwait'},
    {'name': 'Kyrgyzstan', 'iso2': 'KG', 'iso3': 'KGZ', 'sapName': 'Kyrgyzstan'},
    {'name': 'Lao People\'s Democratic Republic', 'iso2': null, 'iso3': null, 'sapName': 'Lao People\'s Democratic Republic'},
    {'name': 'Latvia', 'iso2': 'LV', 'iso3': 'LVA', 'sapName': 'Latvia'},
    {'name': 'Lebanon', 'iso2': 'LB', 'iso3': 'LBN', 'sapName': 'Lebanon'},
    {'name': 'Lesotho', 'iso2': 'LS', 'iso3': 'LSO', 'sapName': 'Lesotho'},
    {'name': 'Liberia', 'iso2': 'LR', 'iso3': 'LBR', 'sapName': 'Liberia'},
    {'name': 'Liechtenstein', 'iso2': 'LI', 'iso3': 'LIE', 'sapName': 'Liechtenstein'},
    {'name': 'Lithuania', 'iso2': 'LT', 'iso3': 'LTU', 'sapName': 'Lithuania'},
    {'name': 'Luxembourg', 'iso2': 'LU', 'iso3': 'LUX', 'sapName': 'Luxembourg'},
    {'name': 'Macao', 'iso2': 'MO', 'iso3': 'MAC', 'sapName': 'Macao'},
    {'name': 'Madagascar', 'iso2': 'MG', 'iso3': 'MDG', 'sapName': 'Madagascar'},
    {'name': 'Malawi', 'iso2': 'MW', 'iso3': 'MWI', 'sapName': 'Malawi'},
    {'name': 'Malaysia', 'iso2': 'MY', 'iso3': 'MYS', 'sapName': 'Malaysia'},
    {'name': 'Maldives', 'iso2': 'MV', 'iso3': 'MDV', 'sapName': 'Maldives'},
    {'name': 'Mali', 'iso2': 'ML', 'iso3': 'MLI', 'sapName': 'Mali'},
    {'name': 'Malta', 'iso2': 'MT', 'iso3': 'MLT', 'sapName': 'Malta'},
    {'name': 'Marshall Islands', 'iso2': 'MH', 'iso3': 'MHL', 'sapName': 'Marshall Islnds'},
    {'name': 'Martinique', 'iso2': 'MQ', 'iso3': 'MTQ', 'sapName': 'Martinique'},
    {'name': 'Mauritania', 'iso2': 'MR', 'iso3': 'MRT', 'sapName': 'Mauritania'},
    {'name': 'Mauritius', 'iso2': 'MU', 'iso3': 'MUS', 'sapName': 'Mauritius'},
    {'name': 'Mayotte', 'iso2': 'YT', 'iso3': 'MYT', 'sapName': 'Mayotte'},
    {'name': 'Mexico', 'iso2': 'MX', 'iso3': 'MEX', 'sapName': 'Mexico'},
    {'name': 'Monaco', 'iso2': 'MC', 'iso3': 'MCO', 'sapName': 'Monaco'},
    {'name': 'Mongolia', 'iso2': 'MN', 'iso3': 'MNG', 'sapName': 'Mongolia'},
    {'name': 'Montenegro', 'iso2': 'ME', 'iso3': 'MNE', 'sapName': 'Montenegro'},
    {'name': 'Montserrat', 'iso2': 'MS', 'iso3': 'MSR', 'sapName': 'Montserrat'},
    {'name': 'Morocco', 'iso2': 'MA', 'iso3': 'MAR', 'sapName': 'Morocco'},
    {'name': 'Mozambique', 'iso2': 'MZ', 'iso3': 'MOZ', 'sapName': 'Mozambique'},
    {'name': 'Myanmar', 'iso2': 'MM', 'iso3': 'MMR', 'sapName': 'Myanmar'},
    {'name': 'Namibia', 'iso2': 'NA', 'iso3': 'NAM', 'sapName': 'Namibia'},
    {'name': 'Nauru', 'iso2': 'NR', 'iso3': 'NRU', 'sapName': 'Nauru'},
    {'name': 'Nepal', 'iso2': 'NP', 'iso3': 'NPL', 'sapName': 'Nepal'},
    {'name': 'Netherlands', 'iso2': 'NL', 'iso3': 'NLD', 'sapName': 'Netherlands'},
    {'name': 'New Caledonia', 'iso2': 'NC', 'iso3': 'NCL', 'sapName': 'New Caledonia'},
    {'name': 'New Zealand', 'iso2': 'NZ', 'iso3': 'NZL', 'sapName': 'New Zealand'},
    {'name': 'Nicaragua', 'iso2': 'NI', 'iso3': 'NIC', 'sapName': 'Nicaragua'},
    {'name': 'Niger', 'iso2': 'NE', 'iso3': 'NER', 'sapName': 'Niger'},
    {'name': 'Nigeria', 'iso2': 'NG', 'iso3': 'NGA', 'sapName': 'Nigeria'},
    {'name': 'Niue', 'iso2': 'NU', 'iso3': 'NIU', 'sapName': 'Niue'},
    {'name': 'Norfolk Island', 'iso2': 'NF', 'iso3': 'NFK', 'sapName': 'Norfolk Island'},
    {'name': 'North Korea', 'iso2': 'KP', 'iso3': 'PRK', 'sapName': 'North Korea'},
    {'name': 'Northern Mariana Islands', 'iso2': 'MP', 'iso3': 'MNP', 'sapName': 'N.Mariana Islnd'},
    {'name': 'Norway', 'iso2': 'NO', 'iso3': 'NOR', 'sapName': 'Norway'},
    {'name': 'Oman', 'iso2': 'OM', 'iso3': 'OMN', 'sapName': 'Oman'},
    {'name': 'Pakistan', 'iso2': 'PK', 'iso3': 'PAK', 'sapName': 'Pakistan'},
    {'name': 'Palau', 'iso2': 'PW', 'iso3': 'PLW', 'sapName': 'Palau'},
    {'name': 'Palestinian Aut', 'iso2': 'PS', 'iso3': 'PSE', 'sapName': 'Palestinian Aut'},
    {'name': 'Panama', 'iso2': 'PA', 'iso3': 'PAN', 'sapName': 'Panama'},
    {'name': 'Papua New Guinea', 'iso2': 'PG', 'iso3': 'PNG', 'sapName': 'Papua Nw Guinea'},
    {'name': 'Paraguay', 'iso2': 'PY', 'iso3': 'PRY', 'sapName': 'Paraguay'},
    {'name': 'Peru', 'iso2': 'PE', 'iso3': 'PER', 'sapName': 'Peru'},
    {'name': 'Philippines', 'iso2': 'PH', 'iso3': 'PHL', 'sapName': 'Philippines'},
    {'name': 'Pitcairn', 'iso2': 'PN', 'iso3': 'PCN', 'sapName': 'Pitcairn'},
    {'name': 'Poland', 'iso2': 'PL', 'iso3': 'POL', 'sapName': 'Poland'},
    {'name': 'Portugal', 'iso2': 'PT', 'iso3': 'PRT', 'sapName': 'Portugal'},
    {'name': 'Puerto Rico', 'iso2': 'PR', 'iso3': 'PRI', 'sapName': 'Puerto Rico'},
    {'name': 'Qatar', 'iso2': 'QA', 'iso3': 'QAT', 'sapName': 'Qatar'},
    {'name': 'Réunion', 'iso2': null, 'iso3': null, 'sapName': 'Réunion'},
    {'name': 'Republic of North Macedonia', 'iso2': 'MK', 'iso3': 'MKD', 'sapName': 'Republic of North Macedonia'},
    {'name': 'Romania', 'iso2': 'RO', 'iso3': 'ROU', 'sapName': 'Romania'},
    {'name': 'Rwanda', 'iso2': 'RW', 'iso3': 'RWA', 'sapName': 'Rwanda'},
    {'name': 'Saint Kitts and Nevis', 'iso2': 'KN', 'iso3': 'KNA', 'sapName': 'St Kitts&Nevis'},
    {'name': 'Saint Lucia', 'iso2': 'LC', 'iso3': 'LCA', 'sapName': 'Saint Lucia'},
    {'name': 'Saint Pierre and Miquelon', 'iso2': 'PM', 'iso3': 'SPM', 'sapName': 'St.Pier,Miquel.'},
    {'name': 'Saint Vincent and the Grenadines', 'iso2': 'VC', 'iso3': 'VCT', 'sapName': 'Saint Vincent and the Grenadines'},
    {'name': 'Samoa', 'iso2': 'WS', 'iso3': 'WSM', 'sapName': 'Samoa'},
    {'name': 'San Marino', 'iso2': 'SM', 'iso3': 'SMR', 'sapName': 'San Marino'},
    {'name': 'Sao Tome and Principe', 'iso2': 'ST', 'iso3': 'STP', 'sapName': 'S.Tome,Principe'},
    {'name': 'Saudi Arabia', 'iso2': 'SA', 'iso3': 'SAU', 'sapName': 'Saudi Arabia'},
    {'name': 'Senegal', 'iso2': 'SN', 'iso3': 'SEN', 'sapName': 'Senegal'},
    {'name': 'Serbia', 'iso2': 'RS', 'iso3': 'SRB', 'sapName': 'Serbia'},
    {'name': 'Seychelles', 'iso2': 'SC', 'iso3': 'SYC', 'sapName': 'Seychelles'},
    {'name': 'Sierra Leone', 'iso2': 'SL', 'iso3': 'SLE', 'sapName': 'Sierra Leone'},
    {'name': 'Singapore', 'iso2': 'SG', 'iso3': 'SGP', 'sapName': 'Singapore'},
    {'name': 'Slovakia', 'iso2': 'SK', 'iso3': 'SVK', 'sapName': 'Slovakia'},
    {'name': 'Slovenia', 'iso2': 'SI', 'iso3': 'SVN', 'sapName': 'Slovenia'},
    {'name': 'Solomon Islands', 'iso2': 'SB', 'iso3': 'SLB', 'sapName': 'Solomon Islands'},
    {'name': 'Somalia', 'iso2': 'SO', 'iso3': 'SOM', 'sapName': 'Somalia'},
    {'name': 'South Africa', 'iso2': 'ZA', 'iso3': 'ZAF', 'sapName': 'South Africa'},
    {'name': 'South Georgia and the South Sandwich Islands', 'iso2': 'GS', 'iso3': 'SGS', 'sapName': 'S. Georgia & S.'},
    {'name': 'South Korea', 'iso2': 'KR', 'iso3': 'KOR', 'sapName': 'South Korea'},
    {'name': 'Spain', 'iso2': 'ES', 'iso3': 'ESP', 'sapName': 'Spain'},
    {'name': 'Sri Lanka', 'iso2': 'LK', 'iso3': 'LKA', 'sapName': 'Sri Lanka'},
    {'name': 'Sudan', 'iso2': 'SD', 'iso3': 'SDN', 'sapName': 'Sudan'},
    {'name': 'Suriname', 'iso2': 'SR', 'iso3': 'SUR', 'sapName': 'Suriname'},
    {'name': 'Swaziland', 'iso2': 'SZ', 'iso3': 'SWZ', 'sapName': 'Swaziland'},
    {'name': 'Sweden', 'iso2': 'SE', 'iso3': 'SWE', 'sapName': 'Sweden'},
    {'name': 'Switzerland', 'iso2': 'CH', 'iso3': 'CHE', 'sapName': 'Switzerland'},
    {'name': 'Syrian Arab Republic', 'iso2': null, 'iso3': null, 'sapName': 'Syrian Arab Republic'},
    {'name': 'Taiwan', 'iso2': 'TW', 'iso3': 'TWN', 'sapName': 'Taiwan'},
    {'name': 'Tajikistan', 'iso2': 'TJ', 'iso3': 'TJK', 'sapName': 'Tajikistan'},
    {'name': 'Thailand', 'iso2': 'TH', 'iso3': 'THA', 'sapName': 'Thailand'},
    {'name': 'Timor-Leste', 'iso2': null, 'iso3': null, 'sapName': 'Timor-Leste'},
    {'name': 'Togo', 'iso2': 'TG', 'iso3': 'TGO', 'sapName': 'Togo'},
    {'name': 'Tokelau', 'iso2': 'TK', 'iso3': 'TKL', 'sapName': 'Tokelau'},
    {'name': 'Tonga', 'iso2': 'TO', 'iso3': 'TON', 'sapName': 'Tonga'},
    {'name': 'Trinidad and Tobago', 'iso2': 'TT', 'iso3': 'TTO', 'sapName': 'Trinidad,Tobago'},
    {'name': 'Tunisia', 'iso2': 'TN', 'iso3': 'TUN', 'sapName': 'Tunisia'},
    {'name': 'Turkey', 'iso2': 'TR', 'iso3': 'TUR', 'sapName': 'Turkey'},
    {'name': 'Turkmenistan', 'iso2': 'TM', 'iso3': 'TKM', 'sapName': 'Turkmenistan'},
    {'name': 'Turks and Caicos Islands', 'iso2': 'TC', 'iso3': 'TCA', 'sapName': 'Turks and Caico'},
    {'name': 'Tuvalu', 'iso2': 'TV', 'iso3': 'TUV', 'sapName': 'Tuvalu'},
    {'name': 'Uganda', 'iso2': 'UG', 'iso3': 'UGA', 'sapName': 'Uganda'},
    {'name': 'Ukraine', 'iso2': 'UA', 'iso3': 'UKR', 'sapName': 'Ukraine'},
    {'name': 'United Arab Emirates', 'iso2': 'AE', 'iso3': 'ARE', 'sapName': 'Utd.Arab Emir.'},
    {'name': 'United Kingdom', 'iso2': 'GB', 'iso3': 'GBR', 'sapName': 'United Kingdom'},
    {'name': 'United States', 'iso2': 'US', 'iso3': 'USA', 'sapName': 'United States'},
    {'name': 'United States Minor Outlying Islands', 'iso2': 'UM', 'iso3': 'UMI', 'sapName': 'United States Minor Outlying Islands'},
    {'name': 'Uruguay', 'iso2': 'UY', 'iso3': 'URY', 'sapName': 'Uruguay'},
    {'name': 'Uzbekistan', 'iso2': 'UZ', 'iso3': 'UZB', 'sapName': 'Uzbekistan'},
    {'name': 'Vanuatu', 'iso2': 'VU', 'iso3': 'VUT', 'sapName': 'Vanuatu'},
    {'name': 'Venezuela', 'iso2': 'VE', 'iso3': 'VEN', 'sapName': 'Venezuela'},
    {'name': 'Vietnam', 'iso2': 'VN', 'iso3': 'VNM', 'sapName': 'Viet Nam'},
    {'name': 'Wallis and Futuna', 'iso2': 'WF', 'iso3': 'WLF', 'sapName': 'Wallis and Futuna'},
    {'name': 'Yemen', 'iso2': 'YE', 'iso3': 'YEM', 'sapName': 'Yemen'},
    {'name': 'Zambia', 'iso2': 'ZM', 'iso3': 'ZMB', 'sapName': 'Zambia'},
    {'name': 'Zimbabwe', 'iso2': 'ZW', 'iso3': 'ZWE', 'sapName': 'Zimbabwe'},
];
